// Init Youtube background videos
const backgroundVideos = () => {
  window.onYouTubeIframeAPIReady = function() {
    $('.js-background-video-youtube').each(function() {
      const $video = $(this);
      const videoId = $video.data('youtube-id');

      const player = new YT.Player(this, {
        videoId: videoId,
        playerVars: {
          autoplay: 1, // Auto-play the video on load
          playsinline: 1,
          loop: 1, // Run the video in a loop
          controls: 0, // Show pause/play buttons in player
          showinfo: 0, // Hide the video title
          modestbranding: 1, // Hide the Youtube Logo
          fs: 0, // Hide the full screen button
          cc_load_policy: 0, // Hide closed captions
          iv_load_policy: 3, // Hide the Video Annotations
          autohide: 0, // Hide video controls when playing
        },
        events: {
          onReady: function (event) {
            event.target.mute();
            event.target.playVideo();
          },
          onStateChange: function (event) {
            // video ended
            if (event.data == 0) {
              event.target.playVideo();
            }
          }
        }
      })
    })
  }
}

backgroundVideos();

